module.exports = __webpack_public_path__ + "static/media/buy_payment_3.4136c322.jpg";